import styled from 'styled-components';

// ============================================================
// STYLED COMPONENTS FOR CATEGORY SELECTOR
// ============================================================

/* Odstępy i rozmiar etykiety zgodne z HeroUI Input size="lg" labelPlacement="outside",
   żeby pole stało w jednej linii z sąsiednimi inputami. */
export const CategoryFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

export const CategoryLabel = styled.label`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};
`;

export const CategorySelector = styled.button<{ $hasError?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 12px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#ffffff')};
  border: 1px solid ${({ $hasError, theme }) => {
    if ($hasError) return '#ef4444';
    return theme.mode === 'dark' ? '#374151' : '#d1d5db';
  }};
  border-radius: 6px;
  font-size: 14px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#374151')};
  cursor: pointer;
  height: 50px;

  outline: none;
  transition: background-color 0.15s ease;

  &:hover,
  &:focus-visible {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#2a313b' : '#f9fafb')};
  }

  svg {
    width: 18px;
    height: 18px;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  }
`;

export const CategoryPlaceholder = styled.span`
  color: ${({ theme }) => (theme.mode === 'dark' ? '#6b7280' : '#9ca3af')};
`;

export const CategoryPopoverContent = styled.div<{ $width?: number }>`
  display: flex;
  flex-direction: column;
  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
  max-height: 350px;
  overflow-y: auto;
`;

export const CategoryItem = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: ${({ $active, theme }) => {
    if ($active) return theme.mode === 'dark' ? 'rgba(224, 123, 45, 0.1)' : 'rgba(224, 123, 45, 0.05)';
    return 'transparent';
  }};
  border: none;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  color: ${({ $active, theme }) => {
    if ($active) return '#1a4d4d';
    return theme.mode === 'dark' ? '#f3f4f6' : '#1e293b';
  }};
  cursor: pointer;
  text-align: left;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
  }

  svg {
    width: 18px;
    height: 18px;
    color: #1a4d4d;
  }
`;

export const AddCategoryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: transparent;
  border: none;
  border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  font-size: 14px;
  font-weight: 300;
  color: #047857;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: #ef4444;
`;
